import type { PressEvent } from "@react-types/shared";
import { clsx } from "clsx";
import type { CSSProperties, FC, HTMLAttributes, PropsWithChildren, ReactElement, ReactNode, Ref } from "react";
import { TriggerButton, TriggerButtonIntent, TriggerButtonSize } from "widgets";

import style from "../../styles/Cells.module.scss";

export interface TableCellProps {
  icon?: ReactNode;
  children?: ReactNode;
  triggerButtonProps?: {
    intent?: TriggerButtonIntent;
    icon: ReactElement | string;
    label: string;
    "aria-label"?: string;
    shortcut?: string;
    domProps?: HTMLAttributes<HTMLButtonElement>;
    onPress: (event: PressEvent) => void | Promise<unknown>;
    tooltip?: string;
    ref?: Ref<HTMLButtonElement>;
    isDisabled?: boolean;
    /** For e2e */
    e2eActionId?: string;
  };
  alternativeButton?: ReactNode;
  style?: CSSProperties;
  className?: string;
  editor?: boolean;
}

export const TableCell: FC<PropsWithChildren<TableCellProps>> = (props) => {
  return (
    <div className={clsx(style.cell, { [style.editor]: props.editor })}>
      {props.icon && <div className={style.icon}>{props.icon}</div>}
      {props.children && (
        <div className={clsx(style.content_ellipsis, props.className)} style={props.style}>
          {props.children}
        </div>
      )}
      {props.triggerButtonProps && (
        <TriggerButton
          icon={props.triggerButtonProps.icon}
          label={props.triggerButtonProps.label}
          aria-label={props.triggerButtonProps["aria-label"]}
          intent={props.triggerButtonProps.intent ?? TriggerButtonIntent.Secondary}
          onPress={props.triggerButtonProps.onPress}
          ref={props.triggerButtonProps.ref}
          size={TriggerButtonSize.Small}
          isDisabled={props.triggerButtonProps.isDisabled}
          data-e2e-action={props.triggerButtonProps.e2eActionId}
        />
      )}
      {props.alternativeButton && <div style={{ lineHeight: "1" }}>{props.alternativeButton}</div>}
    </div>
  );
};
